<template>
	<div class="newsdetail">
		<div class="banner">
			<img v-if="inwidth>768" :src="banner" alt="">
			<img v-else :src="phone_pic" alt="">
		</div>
		<div class="content">
			<div class="title">
				<div class="mytit1">{{mytit.title}}</div>
				<div class="mytit2">
					<div>Date: {{mytit.add_time}}</div>
					<div>Source: {{mytit.source}}</div>
				</div>
			</div>
			<!-- <div class="newsban"><img src="../../../static/images/newsdetail.png" alt=""></div> -->
			<div class="main">
				<div class="maintit" v-html="mytit.content"></div>
				<div class="return">
					<div class="relt">
						<div @click="goDetail(mynext.prev_id)">Previous: {{mynext.prev_title}}</div>
						<div @click="goDetail(mynext.next_id)">Next: {{mynext.next_title}}</div>
					</div>
					<div v-if="inwidth>768" class="rert" @click="goback">
						<img src="../../../static/images/newsreturn.png" alt="">
						return
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		name: "newsdetail",
		data() {
			return {
				inwidth:window.innerWidth,
				newsid: '',
				mytit:'',
				banner:'',
				mynext:'',
				phone_pic:'',
			}
		},
		created() {
			this.newsid = this.$route.query.newsid;
			this.getData()
		},
		methods: {
			goback(){//返回
				this.$router.go(-1);
			},
			getData() {
			  var that = this;
			  let data = {id:that.newsid};
			  that.$api.newsDetail(data).then(res => {
				if (res.status == 1) {
					that.banner = res.data.banner;
					that.phone_pic= res.data.phone_pic;
					that.mytit = res.data.list;
					that.mynext = res.data.prev_next;
				} else {
				  that.$message({
					message: res.msg,
					type: "warning"
				  });
				}
			  });
			},
			goDetail(id){
				this.$router.push({path:'/newsDetail', query:{newsid:id}});
				window.location.reload();
			}
	
		}
	}
</script>

<style>
	.newsdetail{
		width: 100%;
		background: #fff;
	}
	.newsdetail .banner{
		width: 100%;
	}
	.newsdetail .banner img{
		width: 100%;
		display: block;
	}
	.newsdetail .content {
		width: 120rem;
		margin: 0 auto;
		padding: 3.0rem 0 5.0rem;
	}

	.newsdetail .title {
		width: 100%;
		padding: 1.6rem 0 3.5rem;
		text-align: center;
		font-size: 1.6rem;
		color: #4c4c4c;
	}

	.newsdetail .title .mytit1 {
		width: 100%;
		margin:0 auto 1rem;
		font-size: 2.4rem;
		line-height: 3.2rem;
	}

	.newsdetail .title .mytit2 {
		font-size: 1.4rem;
		color: #4c4c4c;
		display: flex;
		justify-content: center;
		align-items: center;
		font-family: HelveticaNeueLTPro-Roman, sans-serif;
	}
	.newsdetail .title .mytit2 div:first-child{
		margin-right: 10rem;
	}
	.newsdetail .newsban{
		width: 100%;
	}
	.newsdetail .newsban img{
		width: 100%;
		display: block;
	}
	.newsdetail .main{
		width: 100%;
		padding: 3.0rem 0;
	}
	.newsdetail .main .maintit{
		text-align: left;
		font-size: 1.4rem;
		color: #808080;
		line-height: 3.0rem;
		margin-bottom: 3.0rem;
	}
	.newsdetail .main .maintit p{
		margin-bottom: 2.0rem;
		font-size: 1.6rem;
		/*word-wrap: break-word; 
		word-break: break-all;
		white-space: pre-wrap; */
		text-align:justify; 
		text-justify:inter-ideograph;
	}
	.newsdetail .main .maintit img{
		width: 100%;
		display: block;
	}
	.newsdetail .main .return{
		border-top: 1px solid #e0e0e0;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-top: 3.5rem;
		font-size: 1.4rem;
		color: #808080;
	}
	.return .relt div{
		cursor: pointer;
	}
	.return .relt div:last-child{
		margin-top: 2.0rem;
		color: #4c4c4c;
	}
	.return .rert{
		display: flex;
		align-items: center;
		color: #333;
		cursor: pointer;
	}
	.return .rert img{
		width: 3.6rem;
		height: 3.0rem;
		margin-right:2.0rem ;
	}
	@media(max-width:1200px) {
		.newsdetail .content{
			width: 92%;
		}
	}
	@media(max-width:768px) {
		.newsdetail .content{
			width:85%;
		}
		.newsdetail .banner img {
			height: 40.0rem;
			object-fit: cover;
		}
	}
</style>
